<template>
    <div class="container">
        <div class="row page-content">
            <div class="col-12">
                <h1 class="page-heading text-dark collection-heading">
                    <img v-if="collection.icon_url" :src="collection.icon_url" alt="" class="float-end collection-icon">
                    <img v-else src="/assets/dipocaco/pocas/collection.png" alt="collection-poca" class="page-poca">

                    <small class="muted">{{ $t('collections.collection') }}</small><br/>
                    {{ collection.name }}
                </h1>
            </div>

            <div class="col-6 my-1" v-if="collection && collection.description && collection.description.length > 0">
                <h6>{{ $t('collections.description') }}</h6>
                <p v-html="formattedDescription"></p>
            </div>

            <div class="col-6 my-1" v-if="collection.cards?.length && !collection.set">
                <h6>{{ $t('collections.value') }}</h6>
                <span>{{ collectionWorth }} <currency-icon/></span>
            </div>

            <div class="col-12 mb-3 va-middle">
                <span class="float-end card-counter" v-if="collection.set">
                    {{ collection.cards?.length }} / {{ collection.set?.cards?.length }}
                </span>

                <span class="float-end card-counter" v-if="!collection.set && isOwnCollection">
                    <a class="btn btn-sm btn-secondary mt-0" v-on:click="openSettingsModal"><i class="fa-solid fa-cogs"></i></a>
                </span>

                <router-link to="/collections" class="btn btn-sm btn-success mt-1" v-if="isOwnCollection">
                    {{ $t('collections.back') }}
                </router-link>

                <a href="javascript:" onclick="history.back()" class="btn btn-sm btn-success mt-1" v-else>
                    {{ $t('collections.backProfile') }}
                </a>
            </div>

            <div class="col-12 p-0">
                <div class="row p-0" style="display: flex;">
                    <template v-for="card in (collection.set?.cards ?? collection.cards)">
                        <div v-if="card.rarity !== 'LEGEND' && card.name.search('-UNION') === -1" class="col-xxl-1 col-xl-2 col-lg-2 col-md-3 col-sm-3 col-4 text-center collection-card">
                            <a href="javascript:" class="text-left mb-2" v-on:click="cardClick(card)">
                                <div class="badge float-end" v-if="collection.allow_duplicates && card.userCollectionCard.quantity > 1">
                                    {{ card.userCollectionCard.quantity }}
                                </div>

                                <img loading="lazy" v-if="collection.set_id" :src="cardCollectionIds.includes(card.card_id) ? getSmallCardImageUrl(card) : '/assets/dipocaco/unknown-card.png'"
                                     style="width: auto; max-width: 100%;"
                                     :class="'card-thumbnail '+(cardCollectionIds.includes(card.card_id) ? 'card-in-collection' : 'card-missing-in-collection')"
                                     :data-card-id="card.card_id">

                                <img loading="lazy" v-else :src="getSmallCardImageUrl(card)"
                                     style="width: auto; max-width: 100%;"
                                     :class="'card-thumbnail '+(cardCollectionIds.includes(card.card_id) ? 'card-in-collection' : 'card-missing-in-collection')"
                                     :data-card-id="card.card_id">
                            </a>
                        </div>
                    </template>
                </div>

                <div class="mx-3 alert alert-info" v-if="!collection.cards || collection.cards.length === 0">
                    {{ $t('collections.empty') }}
                </div>
            </div>

            <div class="col-12" v-if="legendCardsFound">
                <h4 class="mt-2 mb-1 pb-0">{{ $t('collections.legendCards') }}</h4>
                <div class="row p-0" style="display: flex;">
                    <template v-for="legendCard in legendCards">
                        <div class="col-12 text-center collection-card legend-card">
                            <a href="javascript:" class="text-left">
                                <img :src="cardCollectionIds.includes(legendCard[0].card_id) ? getSmallCardImageUrl(legendCard[0]) : '/assets/dipocaco/unknown-card.png'" style="width: auto; max-width: 100%;"
                                     :class="'card-thumbnail '+(cardCollectionIds.includes(legendCard[0].card_id) ? 'card-in-collection' : 'card-missing-in-collection')" :data-card-id="legendCard[0].card_id"
                                     v-on:click="cardClick(legendCard[0])">
                                <img :src="cardCollectionIds.includes(legendCard[1].card_id) ? getSmallCardImageUrl(legendCard[1]) : '/assets/dipocaco/unknown-card.png'" style="width: auto; max-width: 100%;"
                                     :class="'card-thumbnail '+(cardCollectionIds.includes(legendCard[1].card_id) ? 'card-in-collection' : 'card-missing-in-collection')" :data-card-id="legendCard[1].card_id"
                                     v-on:click="cardClick(legendCard[1])">
                            </a>
                        </div>
                    </template>
                </div>
            </div>

            <div class="col-12" v-if="unionCardsFound">
                <h4 class="mt-2 mb-1 pb-0">{{ $t('collections.vUnionCards') }}</h4>
                <div class="row p-0" style="display: flex;">
                    <template v-for="unionCard in unionCards">
                        <div class="col-12 text-center collection-card union-card">
                            <a href="javascript:" class="text-left">
                                <img v-if="unionCard[0]" :src="cardCollectionIds.includes(unionCard[0].card_id) ? getSmallCardImageUrl(unionCard[0]) : '/assets/dipocaco/unknown-card.png'" style="width: auto; max-width: 100%;"
                                     :class="'card-thumbnail '+(cardCollectionIds.includes(unionCard[0].card_id) ? 'card-in-collection' : 'card-missing-in-collection')" :data-card-id="unionCard[0].card_id"
                                     v-on:click="cardClick(unionCard[0])">
                                <img v-if="unionCard[1]" :src="cardCollectionIds.includes(unionCard[1].card_id) ? getSmallCardImageUrl(unionCard[1]) : '/assets/dipocaco/unknown-card.png'" style="width: auto; max-width: 100%;"
                                     :class="'card-thumbnail '+(cardCollectionIds.includes(unionCard[1].card_id) ? 'card-in-collection' : 'card-missing-in-collection')" :data-card-id="unionCard[1].card_id"
                                     v-on:click="cardClick(unionCard[1])">
                                <img v-if="unionCard[2]" :src="cardCollectionIds.includes(unionCard[2].card_id) ? getSmallCardImageUrl(unionCard[2]) : '/assets/dipocaco/unknown-card.png'" style="width: auto; max-width: 100%;"
                                     :class="'card-thumbnail '+(cardCollectionIds.includes(unionCard[2].card_id) ? 'card-in-collection' : 'card-missing-in-collection')" :data-card-id="unionCard[2].card_id"
                                     v-on:click="cardClick(unionCard[2])">
                                <img v-if="unionCard[3]" :src="cardCollectionIds.includes(unionCard[3].card_id) ? getSmallCardImageUrl(unionCard[3]) : '/assets/dipocaco/unknown-card.png'" style="width: auto; max-width: 100%;"
                                     :class="'card-thumbnail '+(cardCollectionIds.includes(unionCard[3].card_id) ? 'card-in-collection' : 'card-missing-in-collection')" :data-card-id="unionCard[3].card_id"
                                     v-on:click="cardClick(unionCard[3])">
                            </a>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <div v-if="cardForDetails" class="modal fade" id="remove-card-modal" tabindex="-1" aria-labelledby="#remove-card-modal-label" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="remove-card-modal-label">Collection Card Info</h1>
                    </div>

                    <div class="modal-body">
                        <div class="form-group">
                            <label class="label">{{ $t('collections.cardName') }}</label>
                            {{ cardForDetails.name }}
                        </div>
                        <div class="form-group">
                            <label class="label">{{ $t('collections.cardAdded') }}</label>
                            {{ cardForDetails.added_at }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" v-if="isOwnCollection" id="collection-settings-modal" tabindex="-1" aria-labelledby="#collection-settings-modal-label" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="collection-settings-modal-label">{{ $t('collections.settings') }}</h1>
                    </div>

                    <div class="modal-body">
                        <div class="form-group mb-3">
                            <label class="label">Name</label>
                            <input type="text" class="form-control" v-model="collectionFields.name">
                        </div>
                        <div class="form-group mb-3">
                            <label class="label">{{ $t('collections.description') }}</label>
                            <textarea class="form-control" v-model="collectionFields.description"></textarea>
                        </div>

                        <div class="form-group mb-3">
                            <label class="label">{{ $t('collections.sortBy') }}</label>
                            <select type="text" class="form-control" v-model="collectionFields.sortBy">
                                <option value="added_at">{{ $t('collections.sortFields.date') }}</option>
                                <option value="release">{{ $t('collections.sortFields.release') }}</option>
                                <option value="name">{{ $t('collections.sortFields.name') }}</option>
                                <option value="card_number">{{ $t('collections.sortFields.number') }}</option>
                                <option value="pokedex_number">{{ $t('collections.sortFields.pokeDex') }}</option>
                            </select>
                        </div>

                        <div class="form-check form-switch mb-3 mt-2">
                            <label for="desc" class="form-check-label">{{ $t('collections.sort') }}</label>
                            <input type="checkbox" id="desc" class="form-check-input" v-model="collectionFields.sortDesc">
                        </div>

                        <div class="form-check form-switch mb-3 mt-2">
                            <label for="public" class="form-check-label">{{ $t('collections.public') }}</label>
                            <input type="checkbox" id="public" class="form-check-input" v-model="collectionFields.isPublic">
                        </div>

                        <div class="form-check form-switch mb-3 mt-2">
                            <label for="duplicates" class="form-check-label">{{ $t('collections.allowDuplicates') }}</label>
                            <input type="checkbox" id="duplicates" class="form-check-input" v-model="collectionFields.allowDuplicates">
                        </div>

                        <div class="form-group">
                            <a href="javascript:" class="btn btn-success w-100" v-on:click="updateCollection">{{ $t('collections.update') }}</a>
                            <template v-if="collectionIsCustom">
                                <hr/>
                                <a href="javascript:" class="btn btn-danger w-100" v-on:click="askForDissolution" v-if="collection.cards.length > 0">{{ $t('collections.dissolveButton') }}</a>
                                <a href="javascript:" class="btn btn-danger w-100" v-on:click="askForDeletion" v-else>{{ $t('collections.deleteButton') }}</a>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <card-detail-view-canvas v-if="activeCard" :card="activeCard" :gallery="true" @cardRemoved="fetchCollection()"/>
    </div>
</template>

<script>
import CardService from "../../CardService";
import CardDetailViewCanvas from "../parts/CardDetailViewCanvas.vue";
import CurrencyIcon from "../parts/CurrencyIcon.vue";

export default {
    name: "Collection",
    components: {CurrencyIcon, CardDetailViewCanvas},
    data() {
        return {
            collection: [],
            cards: [],
            set: [],
            legendCards: [],
            legendCardsFound: false,
            unionCards: [],
            unionCardsFound: false,
            activeCard: null,
            cardForDetails: null,
            collectionFields: {}
        }
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.fetchCollection();
    },
    computed: {
        cardCollectionIds() {
            return this.collection.cards.map(card => card.card_id);
        },
        isOwnCollection() {
            return this.collection.user_id === this.$store.state.user.user_id;
        },
        collectionWorth() {
            return (this.collection.cards.map((card) => CardService.getPrice(card))).reduce((sum, a) => sum + a, 0);
        },
        formattedDescription() {
            return this.collection ? this.collection.description.split('\n').map(l => l.escapeHtml()).join('<br/>') : '';
        },
        collectionIsCustom() {
            return !this.collection.set_id;
        }
    },
    methods: {
        fetchCollection() {
            axios.get('/api/collection/' + this.$route.params.collection_id).then((response) => {
                this.collection = response.data.collection;
                this.set = this.collection.set;

                this.collectionFields.id = this.collection.id * 1;
                this.collectionFields.name = this.collection.name.trim();
                this.collectionFields.description = (this.collection.description ?? '').trim();
                this.collectionFields.sortBy = this.collection.sort_by.trim();
                this.collectionFields.sortDesc = this.collection.sort_direction !== 'asc';
                this.collectionFields.isPublic = this.collection.is_public == 1;
                this.collectionFields.allowDuplicates = this.collection.allow_duplicates == 1;

                if (this.collection.set_id) {
                    this.set = this.collection.set;
                    this.collection.cards = this.collection.cards.map(card => {
                        card.userCollectionCard = card;
                        card.userCollectionCardId = card.id;
                        card.collectionIsCustom = this.collectionIsCustom;
                        card.collectionOwnerId = this.collection.user_id;

                        return card;
                    });
                    this.collection.set.cards = this.collection.set.cards.map(c => {
                        c.id = c.card_id;
                        return c;
                    }).sort(function (a, b) {
                        return a.card_id.split('-')[1].replace(/[^0-9]/g, "") - b.card_id.split('-')[1].replace(/[^0-9]/g, "");
                    });
                    this.activeCard = JSON.parse(this.collection.set.cards[0].json);
                    this.legendCards = (Object.groupBy(this.set.cards.filter(c => c.rarity === 'LEGEND'), (c) => c.name));
                    this.legendCardsFound = this.set.cards.filter(c => c.rarity === 'LEGEND').length > 0;
                    this.unionCards = (Object.groupBy(this.set.cards.filter(c => c.name.search('-UNION') > 0), (c) => c.name));
                    this.unionCardsFound = this.set.cards.filter(c => c.name.search('-UNION') > 0).length > 0;
                } else {
                    this.collection.cards = (response.data.cards ? Object.values(response.data.cards) : response.data.collection.cards).map(card => {
                        let cardJson = JSON.parse(card.card.json);
                        cardJson.added_at = card.added_at;
                        cardJson.userCollectionCardId = card.id;
                        cardJson.userCollectionCard = card;
                        cardJson.collectionIsCustom = this.collectionIsCustom;
                        cardJson.collectionOwnerId = this.collection.user_id;
                        cardJson.card_id = cardJson.id;

                        return cardJson;
                    }).sort((a, b) => {
                        switch(this.collection.sort_by) {
                            case "release":
                                return moment(a.released_at) - moment(b.released_at);
                            case 'name':
                                return a.name.localeCompare(b.name);
                            case "card_number":
                                return a.id.split('-')[1].replace(/[^0-9]/g, "") > b.id.split('-')[1].replace(/[^0-9]/g, "");
                            case "pokedex_number":
                                return a.pokedex_number - b.pokedex_number;
                            case "added_at":
                                return moment(a.added_at) - moment(b.added_at);
                        }
                    });

                    if (this.collection.sort_direction !== 'asc') {
                        this.collection.cards = this.collection.cards.reverse();
                    }

                    this.activeCard = this.collection.cards[0];
                    this.legendCards = (Object.groupBy(this.collection.cards.filter(c => c.rarity === 'LEGEND'), (c) => c.name));
                    this.legendCardsFound = this.collection.cards.filter(c => c.rarity === 'LEGEND').length > 0;
                    this.unionCards = (Object.groupBy(this.collection.cards.filter(c => c.name.search('-UNION') > 0), (c) => c.name));
                    this.unionCardsFound = this.collection.cards.filter(c => c.name.search('-UNION') > 0).length > 0;
                }

                this.$forceUpdate();
            })
        },
        getSmallCardImageUrl(card) {
            return CardService.getSmallCardImageUrl(card);
        },
        cardClick(card) {
            if (!this.collection.set_id || this.cardCollectionIds.includes(card.card_id ?? card.id)) {
                if (this.collection.set_id) {
                    let cardJson = JSON.parse(card.json)

                    let cardIsInCollection = this.collection.cards.filter(colCard => colCard.card_id === cardJson.id);
                    if (cardIsInCollection.length > 0) {
                        cardJson.userCollectionCardId = cardIsInCollection[0].userCollectionCardId;
                        cardJson.collectionOwnerId = this.collection.user_id;
                        cardJson.collectionIsCustom = this.collectionIsCustom;
                    }

                    this.activeCard = cardJson;
                } else {
                    this.activeCard = card;
                }

                setTimeout(() => {
                    $("#card-detail-view-canvas").offcanvas('toggle');
                }, 100)
            }
        },
        openSettingsModal() {
            $("#collection-settings-modal").modal('toggle');
        },
        updateCollection() {
            axios.post('/api/collection/update', this.collectionFields).then((response) => {
                if (!response.data.success) {
                    iziToast.warning({title: response.data.message});
                } else {
                    iziToast.success({title: 'Updated collection details'});
                }

                $("#collection-settings-modal").modal('toggle');
                this.fetchCollection();
            })
        },
        askForDissolution() {
            if (confirm('Do you really want to dissolve this collection?')) {
                this.dissolve();
            }
        },
        askForDeletion() {
            if (confirm('Do you really want to delete this empty collection?')) {
                this.dissolve();
            }
        },
        dissolve() {
            axios.post('/api/collection/dissolve', {
                id: this.collection.id
            }).then(response => {
                iziToast.success({title: response.data.message});

                setTimeout(() => {
                    window.location.href = '/collections'
                }, 3000)
            }).catch(error => {
                console.log(error);
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.collection-card {
    margin-bottom: 1em !important;

    .badge {
        background-color: black;
        color: white;
        font-weight: bold;
        font-size: 1rem;
        position: absolute;
        z-index: 50;
    }
}

.collection-card.legend-card {
    padding-top: 0;
    padding-bottom: 0;
    height: -65%;

    img {
        //transform: rotate(90deg);
        display: inline-block;
        max-width: 50% !important;
    }
}

.collection-card.union-card {
    padding-top: 0;
    padding-bottom: 0;
    height: -65%;

    img {
        //transform: rotate(90deg);
        display: inline-block;
        max-width: 50% !important;
    }

    .card-missing-in-collection {
        img {
            padding: 3em;
        }
    }
}

.collection-icon {
    margin-top: 0.4em;
    max-height: 4em;
    max-width: 7em;
}

.card-counter {
    font-size: 1.5em;
    vertical-align: middle;
    padding-top: 0.25em;
}

.va-middle {
    vertical-align: middle;
}

.card-in-collection {
    filter: drop-shadow(1px 1px rgba(0, 0, 0, 0.2));
    border-radius: 7px;
}

.card-missing-in-collection {
    border-radius: 7px;
}
</style>
